<template>
 <div>
   <div  class="content">
<!--     <el-input  v-model="formInfo.edgep" placeholder="Enter data in edgep format" style="width: 500px; margin-left: 42px"></el-input>-->

     <el-form :label-position="labelPosition" label-width="180px" :model="formInfo" ref="formInfo" :rules="rules"
              v-loading="loading"
              element-loading-text="The input data is being submitted, please wait……">
       <el-form-item label="1. Please upload the file or enter the data manually." >

         <el-button round type="success" plain @click="showPosp()">Show example.posp</el-button>
         <el-button round type="success" plain @click="showEdgep()">Show example.edgep</el-button>
         <br>
         <el-radio v-model="formInfo.radio" label="1" style="margin-bottom: 15px">
           <div style="display: inline-block; vertical-align: middle; margin-left: 5px;margin-top: 10px">
             <el-upload
                     class="upload-demo"
                     :on-preview="handlePreview"
                     :on-remove="handleRemove"
                     action=""
                     :http-request="httpRequest"
                     :before-remove="beforeRemove"
                     :multiple="false"
                     :limit="1"
                     :on-exceed="handleExceed"
                     :file-list="formInfo.fileList">
               <el-button type="primary" @click="fun1()">Click to upload .posp file or .edgep file</el-button>

             </el-upload>
             <p>The suffix of the pharmacohpore file should be .posp or .edgep.</p>
           </div>

         </el-radio>

         <br>
<!--         <el-row :gutter="20">-->
<!--           <el-col :span="12" style="background-color: #5daf34">-->


<!--           </el-col>-->
<!--           <el-col :span="12">-->

<!--           </el-col>-->
<!--         </el-row>-->



         <el-radio v-model="formInfo.radio" label="2" style="margin-top: 0px" @click="fun2()">
          Enter data in posp format
           <el-input @input="fun2()" type="textarea"  v-model="formInfo.posp" placeholder="Enter data in posp format" style="width: 500px;margin-left: 50px;"></el-input>
         </el-radio>
         <br>
         <el-radio v-model="formInfo.radio" label="3" style="margin-bottom: 15px">
           Enter data in edgep format
           <el-input type="textarea" @input="fun3()"  v-model="formInfo.edgep" placeholder="Enter data in edgep format" style="width: 500px; margin-left: 42px"></el-input>
         </el-radio>


       </el-form-item>
       <p>The current platform supports pharmacophore hypotheses with a maximum of 8 elements.</p>
       <el-form-item label="2. Enter the number of molecules you want to generate(Range: 2000~50000)."
                     prop="n_mol"
       >
         <el-input v-model.number="formInfo.n_mol"></el-input>
       </el-form-item>
       <p style="float:left;">(Due to the filtering of validity and uniqueness of the generated molecules by the PGMG web server,
         the number of generated molecules may be less than the number you input.)</p>
       <!--      <el-form-item label="3. Please leave your email address and we will send the generated results to your email."-->
       <!--                    prop="email"-->

       <!--      >-->
       <!--        <el-input v-model="formInfo.email"></el-input>-->
       <!--      </el-form-item>-->
       <el-form-item class="submit">
         <el-button type="primary" @click="submitForm">Submit</el-button>
       </el-form-item>
     </el-form>
   </div>
 </div>

</template>

<script>
var sid=""
export default {
  data() {
    return {
      loading:false,
      sid:sid,
      labelPosition: 'top',
      formInfo: {
        posp:"",
        edgep:"",
        fileList: [],
        n_mol: 2000,
      },
      rules: {
        n_mol: [
          // { message: 'The number of molecules cannot be empty'},
          {type: 'number', min:2000,max:50000,message: 'The number of molecules should be numerical.Range: 2000~50000.'}
        ],
      }
    };
  },
  methods: {
    fun1(){
      this.formInfo.radio='1'
    },
    fun2(){
      this.formInfo.radio='2'
    },
    fun3(){
      this.formInfo.radio='3'
    },
    showPosp(){

        window.open("example.posp")
    },
    showEdgep(){

      window.open("example.edgep")
    },
    handleRemove(file, fileList) {
      this.formInfo.fileList.pop();
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The current limit is 1 file selected`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Confirmed to remove ${file.name}?`);
    },
    httpRequest(param) {
      console.log(param);
      this.formInfo.fileList.push(param.file);
    },
    submitForm() {

      const formData = new FormData();

      this.$refs['formInfo'].validate((valid) => {
        if (valid) {

          sid = require('uuid').v1()//生成uuid
          console.log('submit');

          if (this.formInfo.radio === '1')//上传的是文件
          {
            if (this.formInfo.fileList.length == 0) {
              this.$alert('Please upload the file.');
              return;
            }
            this.loading = true
            formData.append("file", this.formInfo.fileList[0], this.formInfo.fileList[0].name);
          }
          else if(this.formInfo.radio === '2')//输入posp格式的数据
          {
            if (this.formInfo.posp == "") {
              this.$alert('Please input data.');
              return;
            }
            this.loading = true
            formData.append("file", new File([''], 'nofile.txt'))
          }
          else if(this.formInfo.radio === '3')//输入edgep格式的数据
          {
            if (this.formInfo.edgep == "") {
              this.$alert('Please input data.');
              return;
            }
            this.loading = true
            formData.append("file", new File([''], 'nofile.txt'))
          }
          formData.append("posp", this.formInfo.posp);
          formData.append("edgep", this.formInfo.edgep);
          formData.append("n_mol", this.formInfo.n_mol);
          formData.append("uid", sid);
          // TODO: change url!!
          axios.post("/getPgmg", formData).then(res => {
            this.loading = false
            console.log(res.data);
            var that = this
            if (res.data.code === 200) {
              // this.$router.push({
              //   path: '/success',
              //   query: {
              //     sid: sid
              //   }
              // })

              //提交成功显示出弹窗
              that.$alert("Your Task is submitted successfully.","Successful",{
                confirmButtonText: "OK",
                callback: action => {

                  this.$router.push({
                    path: '/TemResult',
                    query: {
                      sid: sid
                    }
                  })
                }
              })
            }
          }).catch(err => {
            console.log(err);
            this.$alert('Submit fails!')
          })
        } else {
          this.loading = false
          console.log('error submit!!');
          return false;
        }
      })
    },

  }
}
</script>

<style scoped>
.el-form-item {
  text-align: left;
}

.submit {
  text-align: center;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}

p{
  font-family: "Noto Sans SC";
}
/deep/ .el-textarea__inner{

  /*width: 230px;*/
  height: 40px;
}

/*/deep/ .el-radio__inner{*/
/*margin-top: 0px;*/
/*}*/

</style>
